import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { PointOptionsObject } from 'highcharts';
import { ShiftSchedulingStat } from '../../../../types';

@Component({
  selector: 'lohi-booked-advance',
  templateUrl: './booked-advance.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookedAdvanceComponent implements OnInit {
  @Input() private shifts: ShiftSchedulingStat[];
  @Input() private days: number;
  private sortedShifts: ShiftSchedulingStat[];

  public labels: Array<string>;
  public chart: Chart;

  constructor(private router: Router) {}

  public ngOnInit(): void {
    this.sortedShifts = this.shifts.slice().sort((a, b) => b.advanceBookingPercentage - a.advanceBookingPercentage);
    this.labels = this.sortedShifts.map((value) => value.userName);
    this.chart = new Chart({
      chart: {
        type: 'column',
      },
      title: {
        align: 'left',
        useHTML: true,
        text: `<div class="text-lg font-bold">Shifts Booked In Advance <span class="text-blue-500">${this.days}d</span></div>`,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          title: null,
        },
      ],
      plotOptions: {
        series: {
          events: {
            click: (event) => {
              if (!event.point.options.custom.userId) {
                return;
              }
              this.router.navigate(['drivers', event.point.options.custom.userId]);
            },
          },
        },
      },
      xAxis: {
        type: 'category',
        categories: this.labels,
        visible: true,
      },
      series: [],
      tooltip: {
        formatter() {
          return (
            `<span class="font-bold" style="color: ${this.point.color}">` + this.series.name + '</span> ' + this.y + '%'
          );
        },
      },
    });
    const missedShifts: Array<[string, number] | PointOptionsObject> = [];
    for (const entry of this.sortedShifts) {
      missedShifts.push({
        label: entry.userName,
        custom: {
          userId: entry.userId,
        },
        y: entry.advanceBookingPercentage,
      });
    }
    this.chart.addSeries(
      {
        name: 'Booked In Advance',
        type: 'column',
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#070707'],
            [1, '#3e3e52'],
          ],
        },
        data: missedShifts,
      },
      true,
      true,
    );
  }
}
